import axios from 'axios';
import store from '@/store';
import {getToken} from '@/utils/auth';
import {Message} from 'element-ui';

// create an axios instance
const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API,
    withCredentials: false,
    // timeout: 5000,
});

// request interceptor
service.interceptors.request.use(
  (config) => {
    const { url } = config;  // 获取当前请求的 URL

    // 如果 URL 中包含 'do/do'，则添加 Content-Type 为 application/json
    if (url && url.includes('do/do')) {
      config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
    }

    // 如果请求自定义 IP 地址
    if (config.customIP) {
      config.baseURL = config.customIP;
    }

    // 如果 store 中有 token，添加到请求头
    if (store.getters.token) {
      config.headers.token = `${getToken()}`;
    }

    return config;
  },
  (error) => {
    console.log(error); // for debug
    return Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(
    (response) => {
        const {
            data,
            ret_code,
            ret_msg,
            msg,
        } = response.data;

        if (~~ret_code === 1) {
            Message({
                message: ret_msg || msg || 'Error',
                type: 'error',
                duration: 5 * 1000,
            });
        }

        if (~~ret_code === 1 && msg == 'token验证失败或已过期') {
            window.close();

            alert(`${msg},请重新登录！`);
            localStorage.clear();
            wps.ribbonUI.Invalidate();
        }

        if (~~ret_code === 0) {
            return response.data;
        }

        return data || response.data;
    },
    (error) => {
        const {response} = error || {};

        // 所有接口如果报错，查询token是否失效
        if (localStorage.wps) {
            store.dispatch('user/inspectionToken').catch((err) => {
                console.log('inspectionToken error:', err);
            });
        }

        if (!response) {
            return Promise.reject(error);
        }

        // 校对接口
        const {url} = response.config || {};

        if (url == '/do/do') {
            const err = new Error('Response Error');
            return Promise.reject(err);
        }

        if (response) {
            const {code, message} = response.data || {};

            const err = new Error(message || 'Response Error');
            err.code = code;

            return Promise.reject(err);
        }

        return Promise.reject(error);
    },
);

export default service;
